module.exports = __webpack_public_path__ + "static/media/btn_parents_01_blog.c0dad7ce.png";